import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectIsAuthenticated } from '../../store/adminSlices/auth';
import { useEffect } from 'react';
import { APP_ROUTES } from '../../app.config.vars/routes';
const PrivateRoute = ({ children }) => {
    const navigate = useNavigate();
    const isAuthenticated = useSelector(selectIsAuthenticated);
    useEffect(() => {
        if (!isAuthenticated) {
            navigate(`${APP_ROUTES.adminLogin}?ref=${location.pathname}`, { replace: true });
        }
    }, [isAuthenticated, navigate]);
    return isAuthenticated ? children : null;
};
export default PrivateRoute;
